import containerFuild from '../html-snippets/container-fuild.js';
import css from '../tpl-css/style-section-image-with-text-conven-feet-02.js';
import buttonPrimary from '../../ui-modules/button-primary/raw-html.js';
const btnPrimary = buttonPrimary({
  iconSuffix: {
    show: false,
    src: '',
  },
  text: 'Purchase Now',
  backgroundColor: '#006196',
  color: '#FFFFFF',
  radius: 12,
  policy: {
    show: false,
    colPerView: 0,
    alignContent: 'center',
    items: [],
  },
});
const html = `
<div data-use-custom-width="false" data-custom-width="1204" class="container" data-attribute="container-content"
    style="--custom-width: 1204px;">
    <div data-attribute="wrap-card" data-center-y="true" data-gap-item="60" class="wrap-card" style="--gap-item: 60px;">
        <div class="wrap-content" data-attribute="wrap-content" data-order="1" style="--order-content: 1;">
            <div data-show="true" data-attribute="wrap-rate-card" class="wrap-rate-card">
                <div data-attribute="wrap-stars" data-value="4" class="wrap-stars">
                    <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.7415 0L18.2214 10.7102H29.4828L20.3722 17.3295L23.8521 28.0398L14.7415 21.4205L5.63078 28.0398L9.11075 17.3295L7.9155e-05 10.7102H11.2615L14.7415 0Z"
                            fill="#FFCC00" />
                    </svg>
                    <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.7415 0L18.2214 10.7102H29.4828L20.3722 17.3295L23.8521 28.0398L14.7415 21.4205L5.63078 28.0398L9.11075 17.3295L7.9155e-05 10.7102H11.2615L14.7415 0Z"
                            fill="#FFCC00" />
                    </svg>
                    <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.7415 0L18.2214 10.7102H29.4828L20.3722 17.3295L23.8521 28.0398L14.7415 21.4205L5.63078 28.0398L9.11075 17.3295L7.9155e-05 10.7102H11.2615L14.7415 0Z"
                            fill="#FFCC00" />
                    </svg>
                    <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.7415 0L18.2214 10.7102H29.4828L20.3722 17.3295L23.8521 28.0398L14.7415 21.4205L5.63078 28.0398L9.11075 17.3295L7.9155e-05 10.7102H11.2615L14.7415 0Z"
                            fill="#FFCC00" />
                    </svg>

                </div>
                <div data-attribute="wrap-rating-text" class="wrap-rating-text">
                    <span>14,000+ Happy Customers</span>
                </div>
            </div>
            <div data-show="true" data-attribute="wrap-title" class="wrap-title">
                <h2>You'll Feel the Difference Instantly!</h2>
            </div>
            <div data-attribute="policy-items" data-show="true" class="policy-items" data-color-policy-item="#006196"
                data-background-policy-item="#F2F7F9"
                style="--color-policy-item: #006196; --background-policy-item: #F2F7F9;">
                <div data-attribute="policy-item-content" class="policy-item-content">
                    <img data-attribute="icon-image"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1ec008c6f7cc4af945d82.png"
                        alt="">
                    <span data-attribute="policy-text">Try Risk Free | 30-Day Wear Test Guarantee</span>
                </div>
                <div data-attribute="policy-item-content" class="policy-item-content">
                    <img data-attribute="icon-image"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1ec008c6f7cc4af945d82.png"
                        alt="">
                    <span data-attribute="policy-text">Try Risk Free | 30-Day Wear Test Guarantee</span>
                </div>
            </div>
            <div data-show="true" data-attribute="description-card" class="description-card">
                <p>
                    Our orthopedic shoes are lightweight, comfy, and built for all-day support. With great cushioning
                    and slip-resistant soles, they're perfect for long shifts on any surface.
                </p>
                <p>
                    Whether you're in healthcare, retail, or hospitality, they'll keep your feet, legs, and back feeling
                    good all day.
                </p>
            </div>
            <div data-attribute="wrap-btn-cta" class="wrap-btn-cta">
                ${btnPrimary}
            </div>
        </div>
        <div data-attribute="wrap-image" data-order="2" style="--order-image: 2;" class="wrap-image">
            <div class="wrap-image-item">
                <img data-attribute="image-item"
                    src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1eb30f9da96638dd08bca.png"
                    alt="">
            </div>
        </div>
    </div>
</div>
`;

export default containerFuild(html, css);
